import React from 'react'
import { makeStyles, useTheme } from '@material-ui/styles';
import { Typography, Grid, Card } from '@material-ui/core';
import Switch from "@material-ui/core/Switch";

const useStyles = makeStyles(theme => ({

    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        //  background: 'green'
    },
    gridContainerOuter: {
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding: '0px 6px'
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    divTitle: {
        padding: 14,
        borderBottom: '1px solid lightgrey',
        display: 'flex',
        alignItems: 'center'
    },
    divContent: {
        padding: 12,
    },
    image: {
        margin: 15,
        maxWidth: '100%',
        width: 450,
        [theme.breakpoints.down('xs')]: {
            width: 250,
        },
    }
}));

function SettingsTwo() {
    const classes = useStyles();
    const [state, setState] = React.useState({
        checkedA: false,
        checkedB: false
    });
    const handleChange = name => event => {
        setState({ ...state, [name]: event.target.checked });
    };
    return (
        <div className={classes.root}>
            <div className={classes.titleDiv}>
                <Typography variant="h2">SettingsTwo</Typography>
            </div>
            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Settings 2: Mails Auto Delivery
                            </Typography>
                            <Switch
                                checked={state.checkedA}
                                onChange={handleChange("checkedA")}
                                value="checkedA"
                            />
                        </div>
                        <div className={classes.divContent}>
                            <img
                                alt="Under development"
                                className={classes.image}
                                src="/images/mails2.svg"
                            />
                        </div>
                    </Card>
                </Grid>

            </Grid>


        </div>

    )
}

export default SettingsTwo
